var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "700" },
      model: {
        value: _vm.tagDialogVisible,
        callback: function ($$v) {
          _vm.tagDialogVisible = $$v
        },
        expression: "tagDialogVisible",
      },
    },
    [
      _c("customDialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(" " + _vm._s(_vm.t("tag")) + " "),
                _c("button", { attrs: { id: "dialog_exit" } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/popup_close.png"),
                      id: "btn_img",
                    },
                    on: {
                      click: function ($event) {
                        _vm.tagDialogVisible = false
                      },
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-col",
                  { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "ma-0 pa-0",
                        staticStyle: { height: "300px" },
                        attrs: { cols: "12" },
                      },
                      [
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 pt-2 pb-7",
                            attrs: { align: "start" },
                          },
                          _vm._l(_vm.tagList, function (item) {
                            return _c(
                              "v-col",
                              {
                                key: item.label,
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "auto" },
                              },
                              [
                                item.selected
                                  ? [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "ma-0 pa-2 pt-1 pb-1 pl-3 pr-3 mr-3 mb-4 text-none",
                                          staticStyle: {
                                            "border-radius": "25px",
                                            "font-size": "0.8rem",
                                          },
                                          attrs: {
                                            width: "auto",
                                            height: "auto",
                                            id: "blue_btn",
                                            elevation: "0",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.tagClick(item)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.label.length < 45
                                                  ? item.label
                                                  : item.label.substring(
                                                      0,
                                                      42
                                                    ) + "..."
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "ma-0 pa-2 pt-1 pb-1 pl-3 pr-3 mr-3 mb-4 text-none",
                                          staticStyle: {
                                            "border-radius": "25px",
                                            "font-size": "0.8rem",
                                          },
                                          attrs: {
                                            width: "auto",
                                            height: "auto",
                                            id: "grey_btn",
                                            elevation: "0",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.tagClick(item)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.label.length < 45
                                                  ? item.label
                                                  : item.label.substring(
                                                      0,
                                                      42
                                                    ) + "..."
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                              ],
                              2
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      {
                        staticClass: "ma-0 pa-0 pb-2",
                        attrs: { align: "center", justify: "center" },
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "ma-0 pa-0",
                            attrs: {
                              id: "grey_btn",
                              width: "8rem",
                              height: "2rem",
                            },
                            on: { click: _vm.tagReset },
                          },
                          [_vm._v(_vm._s(_vm.t("reset")))]
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ma-0 pa-0 ml-2",
                            attrs: {
                              id: "grey_btn",
                              width: "8rem",
                              height: "2rem",
                            },
                            on: {
                              click: function ($event) {
                                _vm.tagDialogVisible = false
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.t("cancel")))]
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ma-0 pa-0 ml-2",
                            attrs: {
                              id: "blue_btn",
                              width: "8rem",
                              height: "2rem",
                            },
                            on: { click: _vm.confirm },
                          },
                          [_vm._v(_vm._s(_vm.t("confirm")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }